/*
 * Copyright (c) 2019 Eva Novotná, Juraj Šimon
 */

import Vuex from "vuex";
import home from "./stores/home";

export default new Vuex.Store({
  modules: {
    home
  }
});
